// class NewRelatedProducts extends HTMLElement {
//   connectedCallback() {
//     this.recommendations = this.querySelector('product-recommendations');
//     this.observer = new MutationObserver(() => this.initWhenReady());
//     if (this.recommendations) {
//       this.observer.observe(this.recommendations, { childList: true, subtree: true });
//     }
//     this.initWhenReady();
//   }

//   disconnectedCallback() {
//     this.observer?.disconnect();
//     window.clearTimeout(this.swiperTimer);
//     this.swiper?.destroy(true, true);
//   }

//   initWhenReady() {
//     if (this.swiper || !this.querySelector('.new-related-products__swiper')) return;
//     if (typeof window.Swiper === 'undefined') {
//       window.clearTimeout(this.swiperTimer);
//       this.swiperTimer = window.setTimeout(() => this.initWhenReady(), 50);
//       return;
//     }

//     this.swiper = new window.Swiper(this.querySelector('.new-related-products__swiper'), {
//       slidesPerView: 1.45,
//       spaceBetween: 16,
//       grabCursor: true,
//       watchOverflow: true,
//       navigation: {
//         nextEl: this.querySelector('.new-related-products__nav--next'),
//         prevEl: this.querySelector('.new-related-products__nav--prev'),
//       },
//       breakpoints: {
//         550: { slidesPerView: 2.25, spaceBetween: 18 },
//         750: { slidesPerView: 3.2, spaceBetween: 20 },
//         990: { slidesPerView: 4.15, spaceBetween: 20 },
//       },
//     });
//   }
// }

// if (!customElements.get('new-related-products')) {
//   customElements.define('new-related-products', NewRelatedProducts);
// }

class NewRelatedProducts extends HTMLElement {
  connectedCallback() {
    this.recommendations = this.querySelector('product-recommendations');
    this.observer = new MutationObserver(() => this.initWhenReady());
    if (this.recommendations) {
      this.observer.observe(this.recommendations, { childList: true, subtree: true });
    }
    this.initWhenReady();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    window.clearTimeout(this.swiperTimer);
    this.swiper?.destroy(true, true);
  }
  initWhenReady() {
    if (this.swiper || !this.querySelector('.new-related-products__swiper')) return;
    if (typeof window.Swiper === 'undefined') {
      window.clearTimeout(this.swiperTimer);
      this.swiperTimer = window.setTimeout(() => this.initWhenReady(), 50);
      return;
    }
    this.swiper = new window.Swiper(this.querySelector('.new-related-products__swiper'), {
      slidesPerView: 1.35,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: this.querySelector('.new-related-products__nav--next'),
        prevEl: this.querySelector('.new-related-products__nav--prev'),
      },
    //   scrollbar: {
    //     el: this.querySelector('.new-related-products__scrollbar'),
    //     draggable: true,
    //     dragSize: 'auto',
    //   },
      breakpoints: {
        550: { slidesPerView: 1.5, spaceBetween: 16 },
        750: { slidesPerView: 3.15, spaceBetween: 20 },
        990: { slidesPerView: 4.15, spaceBetween: 24 },
      },
    });
  }
}
if (!customElements.get('new-related-products')) {
  customElements.define('new-related-products', NewRelatedProducts);
}
